import { render, staticRenderFns } from "./UploadFilePhoto.vue?vue&type=template&id=5e2c3aa8"
import script from "./UploadFilePhoto.vue?vue&type=script&lang=js"
export * from "./UploadFilePhoto.vue?vue&type=script&lang=js"
import style0 from "./UploadFilePhoto.vue?vue&type=style&index=0&id=5e2c3aa8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports